<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="table_data.search"></v-text-field>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="table_data.search">
          <template v-slot:item.practice_areas="{ value }">
            <div v-for="(item, idx) in value" :key="idx">
              {{ item.name }}
            </div>
          </template>

          <template v-slot:item.session_types="{ value }">
            <div v-for="(item, idx) in value" :key="idx">
              {{ item.short_name }}
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" class="box-shadow" :to="{name: 'Tutor', params: {tutor_id: item.id}}">open</v-btn>
<!--            <v-icon class="mr-2" @click="openStaffProfilePage(item)">mdi-account</v-icon>-->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    table_data: {
      headers: [
        { text: 'ID', value: 'nickname'},
        { text: 'Name', value: 'full_name'},
        { text: 'Email', value: 'email'},
        { text: 'Position', value: 'profile_type'},
        { text: 'Practice areas', value: 'practice_areas'},
        { text: 'Session Types', value: 'session_types'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',
    },
    api_errors: [],
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/tutors`).then(({data}) => data.data)
    },
  }
}
</script>